"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const form_error_1 = __importDefault(require("@/components/base-form/form-error"));
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const initialValues = {
    [field_names_1.LoginFieldNames.username]: '',
    [field_names_1.LoginFieldNames.password]: '',
};
const LoginForm = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(base_form_1.default, { initialValues: initialValues, validationSchema: schemas_1.LoginSchema, onSubmitPayload: api_payloads_1.loginPayload, formKey: services_1.endpoints.login },
        react_1.default.createElement("div", { className: styles_scss_1.default.loginInputs },
            react_1.default.createElement("div", { className: styles_scss_1.default.loginInputRow },
                react_1.default.createElement(fields_1.TextInputField, { type: "text", name: field_names_1.LoginFieldNames.username, label: constants_1.default.general.email, placeholder: constants_1.default.login.enterEmail, accessory: {
                        default: constants_1.Images.mail,
                        active: constants_1.Images.mailActive,
                        error: constants_1.Images.mailError,
                    } })),
            react_1.default.createElement("div", { className: styles_scss_1.default.loginInputRow },
                react_1.default.createElement(fields_1.PasswordInputField, { name: field_names_1.LoginFieldNames.password, label: constants_1.default.general.password, placeholder: constants_1.default.login.enterPassword, onKeyDownSubmit: true }))),
        react_1.default.createElement(form_error_1.default, { formKey: services_1.endpoints.login }),
        react_1.default.createElement("div", { className: styles_scss_1.default.buttons },
            react_1.default.createElement(buttons_1.SubmitButton, { disableOnErrors: true, className: styles_scss_1.default.loginButton, title: constants_1.default.login.signIn }))),
    react_1.default.createElement("div", { className: styles_scss_1.default.buttons },
        react_1.default.createElement(components_1.Link, { to: constants_1.Routes.ResetPassword, className: styles_scss_1.default.forgetButton }, constants_1.default.login.forgotPassword)),
    react_1.default.createElement("div", { className: styles_scss_1.default.storesCont },
        react_1.default.createElement("a", { href: constants_1.PublicUrls.appStore, target: "_blank", rel: "noreferrer" },
            react_1.default.createElement("img", { className: styles_scss_1.default.appStore, src: constants_1.Images.appStore, alt: "app-store" })),
        react_1.default.createElement("a", { href: constants_1.PublicUrls.playStore, target: "_blank", rel: "noreferrer" },
            react_1.default.createElement("img", { className: styles_scss_1.default.playStore, src: constants_1.Images.playStore, alt: "app-store" })))));
exports.default = LoginForm;
